import { styled } from '@auth0/quantum-product';
export var ButtonsContainer = styled('div')({
    display: 'flex',
    margin: 0,
});
